export default __webpack_public_path__ + "static/media/24.13f10ad2.jpg";